import React from "react"
import Image from "next/image"
import { useSegment } from "tracking"
import { CloseIcon } from "components/SVG"
import type { MultipleProductCard, MultipleProductCardVariant } from "types"
import {
  activeShadeBorder,
  modalShadeSwatch,
  modalButton,
  modalSwatchWrapper,
  outOfStockIcon,
  modalShadeName,
  shadeSelectorContent,
} from "./ShadeSelectorModal.css"

type Props = {
  product: MultipleProductCard
  styleVariant?: "default" | "scrollShadow"
  setActiveShade: React.Dispatch<
    React.SetStateAction<MultipleProductCardVariant | null>
  >
  activeShade: MultipleProductCardVariant | null
  onButtonClick: () => void
}

export const ShadeSelectorModalContentPLP: React.FC<Props> = ({
  product,
  styleVariant = "default",
  setActiveShade,
  activeShade,
  onButtonClick,
}) => {
  const { track } = useSegment()

  const handleShadeClick = (shade: MultipleProductCardVariant) => {
    setActiveShade(shade)
    onButtonClick()
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "Shade Button Clicked",
        location_type: `PLP Shade Button: ${product.brandName} ${product.title} ${shade.shade}`,
      },
    })
  }

  return (
    <div className={shadeSelectorContent[styleVariant]}>
      {product?.variants?.map((shade) => {
        if (!shade) return null
        const isOutOfStock = !shade?.availability?.inStock
        const isActiveShade = shade.sku === activeShade?.sku

        return (
          <button
            type="button"
            key={shade.sku}
            tabIndex={0}
            onClick={() => handleShadeClick(shade)}
            onKeyDown={() => handleShadeClick(shade)}
            className={`${modalButton.plp} ${
              isActiveShade ? activeShadeBorder : ""
            }`}
            style={{ opacity: isOutOfStock ? 0.5 : 1 }}
          >
            <div className={modalSwatchWrapper}>
              {shade.swatch && (
                <Image
                  src={shade?.swatch.src}
                  alt={shade?.shade ?? shade.swatch.description}
                  height="45"
                  width="45"
                  className={modalShadeSwatch}
                />
              )}
              {isOutOfStock && (
                <CloseIcon width="20px" className={outOfStockIcon} />
              )}
            </div>
            <span className={modalShadeName}>{shade.shade}</span>
          </button>
        )
      })}
    </div>
  )
}
